/**
 * Google Analytics 4 Plugin
 * 
 * Privacy-first implementation with consent mode v2.
 * Works with nuxt-gtag module for better integration.
 * Only loads on client-side after page hydration.
 * 
 * This plugin runs after nuxt-gtag initializes and checks for existing consent.
 */
export default defineNuxtPlugin((nuxtApp) => {
  const config = useRuntimeConfig()
  const gaId = config.public.gaId as string | undefined

  if (!gaId) {
    if (import.meta.env.DEV) {
      console.warn('⚠️ Google Analytics ID not configured. Analytics will be disabled.')
      console.warn('   Set GA_MEASUREMENT_ID environment variable to enable analytics.')
    }
    return
  }

  // Check if user has already granted consent and update accordingly
  const requireConsent = config.public.requireConsent === true
  if (requireConsent && process.client) {
    const consentCookie = useCookie<boolean | null>('analytics_consent', { default: () => null })
    
    // Wait for gtag to be available, then update consent if already granted
    nextTick(() => {
      // Only restore consent if user has explicitly granted it (value is true)
      if (consentCookie.value === true) {
        const { gtag } = useGtag()
        gtag('consent', 'update', {
          'analytics_storage': 'granted',
          'ad_storage': 'denied'
        })
        
        if (import.meta.env.DEV) {
          console.log('✅ Analytics consent restored from cookie')
        }
      }
    })
  }

  if (import.meta.env.DEV) {
    console.log('✅ Google Analytics 4 configured with ID:', gaId.substring(0, 10) + '...')
    if (requireConsent) {
      console.log('📝 Consent mode enabled - analytics will wait for user consent')
    }
  }
})
